module.exports = __webpack_public_path__ + "static/3724413-f7e7a2ffde4715fb808d98252dcc4e56.jpg";